class ActiveSessions {
    constructor() {
        this.loadActiveSessionsTables();
    }
    loadActiveSessionsTables(){
        let activeSessionsTab = document.querySelector('a[href="#active_sessions_tab"]');
        activeSessionsTab.addEventListener("click", function() {
            new ActiveSessionsBrowserDatatable();
            new ActiveSessionsAppDatatable();
        }, {once : true});
    }
}
window.ActiveSessions = ActiveSessions;